export default __webpack_public_path__ + "static/media/email-light.5a7009c4.svg";